module.exports = __webpack_public_path__ + "img/invoice-de-female-banner-st.76ed5599.png";